(() => {
  if (window.ssCartRecommendations) return;
  window.ssCartRecommendations = true;
  let pending = false;
  document.addEventListener('change', (event) => {
    const select = event.target.closest('[data-ss-rec-variant]');
    if (!select) return;
    const card = select.closest('[data-ss-rec-card]');
    card.querySelector('[data-ss-rec-add]').disabled = !select.value || pending;
    const price = select.selectedOptions[0]?.dataset.price;
    if (price) card.querySelector('[data-ss-rec-price]').textContent = price;
    card.querySelector('[data-ss-rec-status]').textContent = '';
  });
  document.addEventListener('click', async (event) => {
    const button = event.target.closest('[data-ss-rec-add]');
    if (!button || button.disabled || pending) return;
    event.preventDefault();
    const card = button.closest('[data-ss-rec-card]');
    const select = card.querySelector('[data-ss-rec-variant]');
    if (!select.value) return;
    pending = true;
    const label = button.textContent;
    document.querySelectorAll('[data-ss-rec-add]').forEach(el => el.disabled = true);
    button.textContent = button.dataset.adding;
    try {
      const response = await fetch(window.Shopify.routes.root + 'cart/add.js', {
        method: 'POST',
        headers: {'Content-Type': 'application/json', 'Accept': 'application/json'},
        body: JSON.stringify({items: [{id: Number(select.value), quantity: 1}]})
      });
      const data = await response.json();
      if (!response.ok || data.status >= 400) throw new Error(data.description || button.dataset.error);
      button.textContent = button.dataset.added;
      card.querySelector('[data-ss-rec-status]').textContent = button.dataset.added;
    } catch (error) {
      button.textContent = label;
      card.querySelector('[data-ss-rec-status]').textContent = error.message || button.dataset.error;
    } finally {
      pending = false;
      document.querySelectorAll('[data-ss-rec-add]').forEach(el => {
        el.disabled = !el.closest('[data-ss-rec-card]').querySelector('[data-ss-rec-variant]').value;
      });
    }
  });
})();

